import { observer } from 'mobx-react'
import { LegalText } from 'components/DigitalAccountCheck/IntroText/LegalText'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { TrustCards } from './TrustCards'
import { getFooterSeals } from 'components/Footer/getSeals'
import Seals from 'components/Footer/Seals'

const DacFooterWrapper = observer(
  ({ isFfgDacWrapper }: { isFfgDacWrapper: boolean }) => {
    const {
      rootStore: {
        traversalSession: { dacWidgetStep },
        navigation: { currentPageInSession }
      }
    } = useRootStore()

    const isDacPage =
      currentPageInSession && currentPageInSession?.indexOf('dac') > -1

    return (
      <>
        {isFfgDacWrapper ? (
          <Seals seals={getFooterSeals()} itemMargin={16} />
        ) : (
          <>
            <TrustCards />
          </>
        )}
        {isDacPage && dacWidgetStep === 'BANK_LOGIN_STEP' && <LegalText />}
      </>
    )
  }
)

export { DacFooterWrapper }
